<!-- 払い戻し時、ticketの情報更新に失敗した場合に表示するダイアログ -->
<template>
  <ItemDialog ref="ticketRefundError" imageType="alert">
    <template v-slot:content-area>
      <p class="text-center">
        払い戻しに失敗しました。お手数ですがサポートセンターにお問い合わせください。
      </p>
    </template>
    <template v-slot:button-area>
      <ItemButton
        label="閉じる"
        actionType="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DialogTicketRefundError",
  setup(props) {
    const ticketRefundError = ref(null);

    const openDialog = () => {
      ticketRefundError.value.open();
    };

    const closeDialog = () => {
      nativeHandlerService.returnNativeAppTopPage();
    };

    return {
      ticketRefundError,
      openDialog,
      closeDialog,
    };
  },
};
</script>
